var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5701 15.3499C11.4241 15.3499 11.2814 15.3932 11.16 15.4743C11.0386 15.5555 10.944 15.6707 10.8881 15.8056C10.8323 15.9405 10.8176 16.0889 10.8461 16.2321C10.8746 16.3753 10.9449 16.5068 11.0481 16.6101C11.1514 16.7133 11.2829 16.7836 11.4261 16.8121C11.5693 16.8406 11.7177 16.826 11.8526 16.7701C11.9875 16.7142 12.1028 16.6196 12.1839 16.4982C12.265 16.3768 12.3083 16.2341 12.3083 16.0881C12.3083 15.8923 12.2305 15.7046 12.0921 15.5661C11.9536 15.4277 11.7659 15.3499 11.5701 15.3499Z",
    fill: "#B246C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5701 7.04556C11.8759 7.04556 12.1237 7.29343 12.1237 7.59918V13.1354C12.1237 13.4412 11.8759 13.6891 11.5701 13.6891C11.2644 13.6891 11.0165 13.4412 11.0165 13.1354V7.59918C11.0165 7.29343 11.2644 7.04556 11.5701 7.04556Z",
    fill: "#B246C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53159 15.5002L9.26474 4.16732C10.2207 2.27756 12.9195 2.27756 13.8755 4.16732L19.6086 15.5002C20.478 17.2187 19.2292 19.25 17.3033 19.25H5.83696C3.91106 19.25 2.66221 17.2187 3.53159 15.5002ZM10.2528 4.66715C10.799 3.58728 12.3412 3.58728 12.8875 4.66715L18.6206 16C19.1174 16.982 18.4038 18.1427 17.3033 18.1427H5.83696C4.73645 18.1427 4.02282 16.982 4.51961 16L10.2528 4.66715Z",
    fill: "#B246C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileErrorIcon);
export default __webpack_public_path__ + "static/media/file-error_icon.96d2d9b18bc420e9f7a20fd9c98cb27c.svg";
export { ForwardRef as ReactComponent };